import type { MeContext } from '@vizit/api';
import { getAccessibleWorkspaces } from './get-accessible';
import { isHierarchical } from './is-hierarchical';
import { isOrgAdmin } from './is-org-admin';

export function canViewOrganizationReports(context: MeContext): boolean {
  if (isOrgAdmin(context)) {
    return true;
  }

  return !isHierarchical(context.organization) && getAccessibleWorkspaces(context).length > 0;
}
